module.exports = __webpack_public_path__ + "img/model_27.68a51d34.jpg";